import React, { Component } from "react";
import { Alert } from "react-bootstrap";

export default class BetterAlerts extends Component {
    render() {
        return (
            <div className={(this.props.errors?.length || this, this.props.success?.length ? `pb-16` : undefined)}>
                {this.props.errors
                    ? this.props.errors.map((obj, i) => {
                          return (
                              <Alert key={i} variant="danger" dismissible={Boolean(this.props.onClose)} onClose={this.props.onClose}>
                                  {obj}
                              </Alert>
                          );
                      })
                    : null}

                {this.props.success
                    ? this.props.success.map((obj, i) => {
                          return (
                              <Alert key={i} variant="success" dismissible={Boolean(this.props.onClose)} onClose={this.props.onClose}>
                                  {obj}
                              </Alert>
                          );
                      })
                    : null}
            </div>
        );
    }
}
